import React from "react";
import { formResponsesPathEntry, useYDoc, viewsPathEntry } from "@/hooks/useY";
import ProcessItem from "./ProcessItem";
import { FormResponse, FormView } from "@/types/form";
import { Box } from "@mui/material";

const ProcessList = () => {
  const [formResponses, setFormResponses] = useYDoc<FormResponse[]>([formResponsesPathEntry], []);
  const [views] = useYDoc<FormView[]>([viewsPathEntry], []);
  const deleteFormResponse = (formResponseId: string) => {
    setFormResponses((prevResponses) =>
      prevResponses.filter((response) => response.id !== formResponseId)
    );
  };

  const displayedFormResponses = [...formResponses].reverse();

  return (
    <Box className="p-4">
      {displayedFormResponses.map((formResponse) => (
        <ProcessItem key={formResponse.id} formResponse={formResponse} deleteFormResponse={deleteFormResponse} views={views} />
      ))}
    </Box>
  );
};

export default ProcessList;
